import { useDispatch } from "react-redux";
import { useCancelAuctionMutation } from "../../../../../toolkit/liveAuction/liveAuctionApi";
import { editAlertDialog, setAlertDialog } from "../../../../../toolkit/alertDialog/alertDialogSlice";

const useCancelAuctionHandler = () => {

  const dispatch = useDispatch();

  const [cancelAuctionApiHandler, cancelAuctionApiData] = useCancelAuctionMutation();

  const onCancelAuctionHandler = async (car) => {
    dispatch(
      setAlertDialog({
        open: true,
        title: `Alert!`,
        message: `Are you sure you want to cancel the auction?`,
        avoidCloseOnOK: true,
        onOk: async () => {

          dispatch(
            editAlertDialog({
              isLoading: true
            })
          );

          const res = await cancelAuctionApiHandler({
            Vehicle_Id: car?.Vehicle_Id
          });

          dispatch(
            editAlertDialog({
              isLoading: false
            })
          );

          if (res?.error || ("status" in res?.data && !res?.data?.status)) {
            dispatch(
              setAlertDialog({
                open: true,
                title: `Error!`,
                message: res?.error?.data?.error || res?.error?.data?.message
                  || res?.data?.message || `Some error occured in cancelling the auction. Please try again!`
              })
            );
          } else {
            dispatch(
              setAlertDialog({
                open: true,
                title: `Success!`,
                message: `The auction was cancelled successfully!`
              })
            );
          }
        }
      })
    )
  };

  return {
    onCancelAuctionHandler
  };
}

export {
  useCancelAuctionHandler
};